var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.80026 1.4C2.80026 1.0287 2.94776 0.672601 3.21031 0.410051C3.47286 0.1475 3.82896 0 4.20026 0L9.94119 0L13.0669 2.0832V10.7333C13.0669 11.1046 12.9194 11.4607 12.6569 11.7233C12.3943 11.9858 12.0382 12.1333 11.6669 12.1333H11.2003V12.6C11.2003 12.9713 11.0528 13.3274 10.7902 13.5899C10.5277 13.8525 10.1716 14 9.80026 14H2.33359C1.96229 14 1.6062 13.8525 1.34364 13.5899C1.08109 13.3274 0.933594 12.9713 0.933594 12.6V3.26667C0.933594 2.89536 1.08109 2.53927 1.34364 2.27672C1.6062 2.01417 1.96229 1.86667 2.33359 1.86667H2.80026V1.4ZM2.80026 2.8H2.33359C2.20983 2.8 2.09113 2.84917 2.00361 2.93668C1.91609 3.0242 1.86693 3.1429 1.86693 3.26667V12.6C1.86693 12.7238 1.91609 12.8425 2.00361 12.93C2.09113 13.0175 2.20983 13.0667 2.33359 13.0667H9.80026C9.92403 13.0667 10.0427 13.0175 10.1302 12.93C10.2178 12.8425 10.2669 12.7238 10.2669 12.6V12.1333H4.20026C3.82896 12.1333 3.47286 11.9858 3.21031 11.7233C2.94776 11.4607 2.80026 11.1046 2.80026 10.7333V2.8Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/docIcon.2a797c562b5bc273a3ca8c5c4d62a040.svg";
export { ForwardRef as ReactComponent };